// BOLDE-owned (lp) — safe to edit on the draft; follow lp/docs/NAMING-STANDARD.md.
(() => {
  const selector = '[data-lp-lifters]';

  function track(event, properties = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event,
      page_type: 'lifter_article',
      awareness: 'problem_aware',
      ...properties,
    });
  }

  function syncThemeChrome() {
    const shouldHide = Boolean(document.querySelector(`${selector}[data-hide-theme-chrome="true"]`));
    document.body.classList.toggle('lp-lifters-template', shouldHide);
  }

  function initialize(root) {
    if (!root || root.dataset.lpInitialized === 'true') return;
    root.dataset.lpInitialized = 'true';

    root.addEventListener('click', (event) => {
      const cta = event.target.closest('[data-lp-cta]');
      if (cta) {
        track('lifter_article_cta_click', { cta_location: cta.dataset.lpCta });
      }

      const summary = event.target.closest('[data-lp-faq]');
      if (summary && !summary.parentElement.open) {
        track('lifter_article_faq_open', { question: summary.textContent.trim() });
      }
    });
  }

  function initializeAll() {
    document.querySelectorAll(selector).forEach(initialize);
    syncThemeChrome();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
  document.addEventListener('shopify:section:unload', syncThemeChrome);
})();
